import axios from "axios";

// Same-origin API base. Always use the relative path "/api" so requests are
// served by whichever domain hosts the frontend (preview, production, or
// custom). This is REQUIRED for cookie-based admin auth to work — a
// cross-origin baseURL (e.g. baking the preview host into a production
// bundle) means the browser will silently drop the authera_admin cookie on
// follow-up calls like /api/auth/me, breaking login.
//
// The k8s ingress routes /api/* to the backend on port 8001 in every
// environment, so a relative path is always correct.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const formatCurrency = (amount, currency = "USD") => {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(Number(amount || 0));
  } catch {
    return `${currency} ${Number(amount || 0).toFixed(2)}`;
  }
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
};

export const truncHash = (h, left = 8, right = 6) => {
  if (!h) return "";
  if (h.length <= left + right + 3) return h;
  return `${h.slice(0, left)}…${h.slice(-right)}`;
};
